import axios from "axios";
import { API_BASE_URL1 } from "../../Services/baseApiUrl";
import axiosInstance from "../../../Hooks/axoisInstance";

const getToken = () => {
  return localStorage.getItem("token");
};

export const AllSecondaryDeploymentReport = async (
  StartDate,
  endDate,
  zoneId,
  circleId,
  ownerTypeId,
  shiftId,
  vehicleTypeId,
  vehicleNumber = "",

) => {
  const ownerId = ownerTypeId == null ? '' : ownerTypeId;
  // const loadingId = LoadingEquipmentId === null ? '' : LoadingEquipmentId;
  const vehicleId = vehicleTypeId == null ? '' : vehicleTypeId;
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TransactionReport/GetAllSecondaryDeploymentTransaction?startDate=${StartDate}&endDate=${endDate}&zoneId=${zoneId}&circleId=${circleId}&ownerTypeId=${ownerId}&shiftId=${shiftId}&VehicleTypeId=${vehicleId}&VehicleNumber=${vehicleNumber}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
    );
    return response;
  } catch (error) {
    throw error;
  }
};


export const AllSecondaryDeploymentTotalReport = async (
  StartDate,
  endDate,
  ownerTypeId,
  vehicleTypeId,
  shiftId
) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TransactionReport/GetAllSecondaryDeploymentTransaction?StartDate=${StartDate}&endDate=${endDate}&ownerTypeId=${ownerTypeId}&VehicleTypeId=${vehicleTypeId}&shiftId=${shiftId}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const AllSecondaryTotalDeploymentReport = async (
  StartDate,
  endDate,
  ownerTypeId,
  shiftId
) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TransactionReport/GetAllSecondaryDeploymentTransaction?StartDate=${StartDate}&endDate=${endDate}&ownerTypeId=${ownerTypeId}&shiftId=${shiftId}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const SecondaryTotalDeploymentReport = async (
  startDate,
  endDate,
  ownerTypeId,
  shiftId
) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `RawReport/GetAllSecondaryDeploymentTransaction?startDate=${startDate}&endDate=${endDate}&ownerTypeId=${ownerTypeId}&shiftId=${shiftId}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const TotalDeploymentReport = async (
  StartDate,
  endDate,
  ownerTypeId,
  shiftId
) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `RawReport/GetAllSecondaryDeploymentTransaction?startDate=${StartDate}&endDate=${endDate}&ownerTypeId=${ownerTypeId}&shiftId=${shiftId}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

